export const AUTO_FETCH_TYPES = {
  CURRENT_PROJECT_ENTITLEMENTS: 'CURRENT_PROJECT_ENTITLEMENTS',
  CURRENT_ACCOUNTS_ENTITLEMENTS: 'CURRENT_ACCOUNTS_ENTITLEMENTS'
};
export const SERVICE_TYPES = {
  GNG: 'gng',
  COLLAB: 'collab',
  QUANTIFICATION: 'quantification',
  COST: 'cost',
  INSIGHT: 'insight',
  FNG: 'fng',
  ASSETS: 'assets',
  PROJECT_HOME: 'project_home',
  DOC_MANAGER: 'doc_manager',
  PROJECT_ADMIN: 'project_admin',
  ACCOUNT_ADMIN: 'account_admin',
  PM: 'pm'
};
export const PRODUCT_IDS = {
  MODEL_COORDINATION: 'modelCoordination',
  DESIGN_COLLABORATION: 'designCollaboration',
  QUANTIFY: 'quantify',
  TAKEOFF: 'takeoff',
  COST: 'cost',
  INSIGHT: 'insight',
  BUILD: 'build',
  DOCS: 'docs',
  ACCOUNT_ADMINISTRATION: 'accountAdministration',
  PROJECT_ADMINISTRATION: 'projectAdministration',
  AUTOSPECS: 'autoSpecs',
  BUILDING_CONNECTED: 'buildingConnected'
};
export const TOOL_IDS = {
  ACTIVITY: 'activity',
  APPS: 'apps',
  ASSETS: 'assets',
  BRIDGE: 'bridge',
  BUDGET: 'budget',
  CORRESPONDENCE: 'correspondence',
  COST: 'cost',
  COSTS: 'costs',
  COMPANIES: 'companies',
  CHANGE_ORDER: 'changeOrder',
  CHANGES: 'changes',
  CLASHES: 'clashes',
  CONFIGURATION: 'configuration',
  DATA_CONNECTOR: 'dataConnector',
  DESIGN: 'design',
  DOCUMENTS: 'documents',
  ESTIMATE: 'estimate',
  FILES: 'files',
  FORECAST: 'forecast',
  FORMS: 'forms',
  HANDOVER: 'handover',
  HOME: 'home',
  ISSUES: 'issues',
  INSIGHT_BUILDER: 'insightBuilder',
  LINKS: 'links',
  LIBRARY: 'library',
  MEETINGS: 'meetings',
  MEMBERS: 'members',
  MODELS: 'models',
  NOTIFICATIONS: 'notifications',
  PHOTOS: 'photos',
  PROJECTS: 'projects',
  PROJECT_CONTROLS: 'projectControls',
  PROJECT_STATUS: 'projectStatus',
  QUALITY: 'quality',
  REPORTS: 'reports',
  REVIEWS: 'reviews',
  RFIS: 'rfis',
  BIDDING: 'bidding',
  RISK: 'risk',
  ROLES: 'roles',
  SAFETY: 'safety',
  SCHEDULE: 'schedule',
  SETTINGS: 'settings',
  SPECS: 'specs',
  SHEETS: 'sheets',
  SUBMITTALS: 'submittals',
  TAKEOFF: 'takeoff',
  TEMPLATES: 'templates',
  TEMPLATE_MEMBERS: 'templateMembers',
  PACKAGES: 'packages',
  TEAM: 'team',
  TEMPLATE_NOTIFICATIONS: 'templateNotifications',
  TRANSMITTALS: 'transmittals',
  VIEWS: 'views',
  WORK_PLAN: 'workPlan',
  CONTROLS_CENTER: 'controlsCenter',
  CLASSIFICATIONS: 'classifications',
  LOCATIONS: 'locations'
};
export const ENTITLEMENTS_PLATFORM_TYPES = {
  ACC: 'acc',
  BIM360: 'bim360'
};
export const PROJECT_CLASSIFICATION_TYPES = {
  PRODUCTION: 'production',
  SAMPLE: 'sample',
  TEMPLATE: 'template'
};
export const USER_ID_TYPE = {
  ID: 'id',
  AUTODESK_ID: 'autodeskId'
};
export const ANALYTICS = {
  FORMAT_USER_ID_NOT_FOUND: 'prodex.format_user_display_name.id_not_found'
};
//# sourceMappingURL=consts.js.map